import { OverlayContainer } from "@angular/cdk/overlay";
import {
  Component,
  DestroyRef,
  effect,
  ElementRef,
  HostListener,
  inject,
  input,
  model,
  OnInit,
  viewChild,
  OnDestroy,
  ChangeDetectionStrategy,
} from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter, startWith, Subscription } from "rxjs";
import { CustomOverlayContainer } from "../../../core/providers/custom-overlay-container";

@Component({
  selector: "claas-main-modal-dialog",
  imports: [],
  templateUrl: "./main-modal-dialog.html",
  styleUrl: "./main-modal-dialog.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    {
      provide: OverlayContainer,
      useFactory: () => new CustomOverlayContainer("[data-main-modal-overlay]"),
    },
  ],
})
export class MainModalDialog implements OnInit, OnDestroy {
  navigateOnBackdropClick = input();

  private destoryRef = inject(DestroyRef);
  router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  dialogRef =
    viewChild.required<ElementRef<HTMLDialogElement>>("mainModalDialog");
  canBeDismissed = input(true);

  show = model(false);

  routerEventSubscription?: Subscription;

  constructor() {
    effect(() => {
      this.toggleShow(this.show());
    });
  }

  ngOnInit() {
    if (this.canBeDismissed()) {
      // Check for openModal flag in child route
      this.routerEventSubscription = this.router.events
        .pipe(
          filter((event) => event instanceof NavigationEnd),
          startWith(null),
        )
        .subscribe(() => {
          const shouldOpen =
            this.activatedRoute.firstChild?.snapshot.data["openModal"];
          if (shouldOpen) {
            this.show.set(true);
          }
        });
      this.destoryRef.onDestroy(() =>
        this.routerEventSubscription?.unsubscribe(),
      );
    }
  }

  ngOnDestroy(): void {
    this.routerEventSubscription?.unsubscribe();
  }

  @HostListener("click", ["$event"])
  onHostClick(evt: MouseEvent) {
    if (
      this.canBeDismissed() &&
      (evt.target === evt.currentTarget ||
        evt.target instanceof HTMLDialogElement)
    ) {
      this.show.set(false);
      if (this.navigateOnBackdropClick()) {
        this.router.navigate([this.navigateOnBackdropClick()]);
      }
    }
  }

  private toggleShow(show: boolean) {
    this.dialogRef().nativeElement?.[show ? "showModal" : "close"]?.();
  }
}
